<div class="modal-header">
  <span class="modal-title">{{ 'PURCHASE_EDIT.LABEL.ATTACH_FILES' | translate }}</span>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ngx-dropzone (change)="onSelect($event)" 
    [maxFileSize]="30 * 1024 * 1024" [multiple]=false [accept]="acceptType ? acceptType : 'application/pdf'">
    <ngx-dropzone-label>Drop files here or <span class="kt-font-brand">browse</span></ngx-dropzone-label>
    <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
      <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
    </ngx-dropzone-preview>
  </ngx-dropzone>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary"
    (click)="activeModal.close('Close click')">{{ 'GENERAL.BUTTONS.CANCEL' | translate }}</button>
  <button class="btn btn-brand" [disabled]="files.length == 0" (click)="save()">
    {{ 'GENERAL.BUTTONS.SAVE' | translate }}</button>
</div>